import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useMaintenance = (): ContextValue => useContext(Context);
